import { generateKeys } from '../utils';
export const paymentCardTokenStatuses = generateKeys({
    unused: {
        value: 'unused',
        label: 'Unused',
        newDepositPermitted: true,
        viewableByClient: true,
    },
    valid: {
        value: 'valid',
        label: 'Valid',
        newDepositPermitted: true,
        viewableByClient: true,
    },
    expired: {
        value: 'expired',
        label: 'Expired',
        newDepositPermitted: false,
        viewableByClient: true,
    },
    removed: {
        value: 'removed',
        label: 'Removed',
        newDepositPermitted: false,
        viewableByClient: false,
    },
    errored: {
        value: 'errored',
        label: 'Errored',
        newDepositPermitted: false,
        viewableByClient: false,
    },
});
